import {BoxWithoutRentals} from '../../../../common/types/box'
import {Rental} from '../../../../common/types/rental'
import {resolveBoxDisplayName} from '../../../../common/utils/resolveBoxDisplayName'

export interface RentalsPerBoxPieData {
  box: string
  count: number
  share: number
}

export const generateRentalsPerBoxPieData = (boxes: BoxWithoutRentals[], rentals: Rental[]): RentalsPerBoxPieData[] => {
  const displayById: Record<string, string> = {}

  // Prefer rentals-derived display names because Rental.box includes Location.
  rentals.forEach((r) => {
    const id = r.box?.id
    if (!id) return
    if (!displayById[id]) {
      displayById[id] = resolveBoxDisplayName(r.box as any)
    }
  })

  // Backfill from boxes if some box ids never appear in rentals (rare, but safe).
  boxes.forEach((b) => {
    if (!displayById[b.id]) {
      displayById[b.id] = resolveBoxDisplayName(b as any)
    }
  })

  const countsById: Record<string, number> = {}
  rentals.forEach((r) => {
    const id = r.box?.id
    if (!id) return
    countsById[id] = (countsById[id] ?? 0) + 1
  })

  const total = Object.values(countsById).reduce((sum, c) => sum + c, 0)

  return Object.entries(countsById)
    .map(([boxId, count]) => ({
      box: displayById[boxId] ?? boxId,
      count,
      share: total > 0 ? Math.round((count / total) * 100) : 0,
    }))
    .sort((a, b) => b.count - a.count)
}
